import { takeEvery,takeLatest, fork, put, all, call } from 'redux-saga/effects';
import { FORGET_USER, RESET_PASSWORD_FORGOT, VALIDATE_RESET_TOKEN } from './actionTypes';
import { forgetUserSuccessful, resetPasswordFailed, resetPasswordSuccessful, userForgetPasswordError, validateResetTokenFailed, validateResetTokenSuccess } from './actions';
import { postForgetPwd, resetPasswordFrgt } from '../../helpers/auth_helper';

function* forgetUser({ payload: { user} }) {
    console.log("User in forget :: ", user)
        try {
            const response = yield call(postForgetPwd, {username: user.useremail});
            if (response) {
              yield put(
                  forgetUserSuccessful(
                  "Email sent!"
                )
              );
          }          
        } catch (error) {
            yield put(userForgetPasswordError("No user found with that email!"));
        }
}
// function* validateReset(action){
// 	try{
// 		const response = yield call(checkResetToken, {token:action.payload});
// 		yield put(validateResetTokenSuccess(response));
// 	}
// 	catch(error){
// 		yield put(validateResetTokenFailed(error));
// 	}
// }
function* resetPassword(action){
	try{
        console.log("Reset Password :: ", action.payload.resetDTO)
		const response = yield call(resetPasswordFrgt, action.payload.resetDTO);
		yield put(resetPasswordSuccessful(response));
	}
	catch(error){
		yield put(resetPasswordFailed(error));
	}
}

export function* watchUserForget() {
    yield takeEvery(FORGET_USER, forgetUser)
    
}

// export function* watchValidateReset(){
//     yield takeLatest(VALIDATE_RESET_TOKEN, validateReset)
// }
export function* watchResetFrgt(){
    yield takeLatest(RESET_PASSWORD_FORGOT, resetPassword)
}
function* forgetSaga() {
    yield all([fork(watchUserForget)]);
    // yield all([fork(watchValidateReset)]);
    yield all([fork(watchResetFrgt)]);
}

export default forgetSaga;